var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFifth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_335)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_839_335)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_839_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 0H16C7.16344 0 0 7.16344 0 16V44C0 52.8366 7.16344 60 16 60H44C52.8366 60 60 52.8366 60 44V16C60 7.16344 52.8366 0 44 0Z",
    fill: "#FFCACA"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M27.28 25.7198H20.8V29.1398C21.08 28.7931 21.48 28.5131 22 28.2998C22.52 28.0731 23.0733 27.9598 23.66 27.9598C24.7267 27.9598 25.6 28.1931 26.28 28.6598C26.96 29.1265 27.4533 29.7265 27.76 30.4598C28.0667 31.1798 28.22 31.9531 28.22 32.7798C28.22 34.3131 27.78 35.5465 26.9 36.4798C26.0333 37.4131 24.7933 37.8798 23.18 37.8798C21.66 37.8798 20.4467 37.4998 19.54 36.7398C18.6333 35.9798 18.12 34.9865 18 33.7598H20.72C20.84 34.2931 21.1067 34.7198 21.52 35.0398C21.9467 35.3598 22.4867 35.5198 23.14 35.5198C23.9267 35.5198 24.52 35.2731 24.92 34.7798C25.32 34.2865 25.52 33.6331 25.52 32.8198C25.52 31.9931 25.3133 31.3665 24.9 30.9398C24.5 30.4998 23.9067 30.2798 23.12 30.2798C22.56 30.2798 22.0933 30.4198 21.72 30.6998C21.3467 30.9798 21.08 31.3531 20.92 31.8198H18.24V23.2598H27.28V25.7198Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0753 25.6119V28.8279C32.0753 29.0519 32.1273 29.2159 32.2313 29.3199C32.3433 29.4159 32.5273 29.4639 32.7833 29.4639H33.5633V30.8799H32.5073C31.0913 30.8799 30.3833 30.1919 30.3833 28.8159V25.6119H29.5913V24.2319H30.3833V22.5879H32.0753V24.2319H33.5633V25.6119H32.0753Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8753 24.136C39.3793 24.136 39.8273 24.248 40.2193 24.472C40.6113 24.688 40.9153 25.012 41.1313 25.444C41.3553 25.868 41.4673 26.38 41.4673 26.98V30.88H39.7873V27.208C39.7873 26.68 39.6553 26.276 39.3913 25.996C39.1273 25.708 38.7673 25.564 38.3113 25.564C37.8473 25.564 37.4793 25.708 37.2073 25.996C36.9433 26.276 36.8113 26.68 36.8113 27.208V30.88H35.1313V22H36.8113V25.06C37.0273 24.772 37.3153 24.548 37.6753 24.388C38.0353 24.22 38.4353 24.136 38.8753 24.136Z",
    fill: "#2A2A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_839_335",
    x: -3,
    y: -3,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_839_335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_839_335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_839_335",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_839_335"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifth);
export default __webpack_public_path__ + "static/media/fifth.40bca4208c8766dbbc7c90dc12fc3262.svg";
export { ForwardRef as ReactComponent };